import { filterNonNullMenuItems, sortMenuItemsByPosition } from './menuItemService';
import type { MenuItem, MenuItemBuilder, MenuItemFilter, MenuItemStrategy } from './typing';

export const createMenuItemBuilder =
    <Product, MenuItemId extends string = string>(
        strategies: MenuItemStrategy<Product, MenuItemId>[],
        additionalFilter?: MenuItemFilter<MenuItemId>,
    ): MenuItemBuilder<Product, MenuItemId> =>
    (product) => {
        const menuItems = strategies
            .map((strategy) => strategy(product))
            .filter<MenuItem<MenuItemId>>(filterNonNullMenuItems)
            .sort(sortMenuItemsByPosition);

        return additionalFilter
            ? menuItems.filter<MenuItem<MenuItemId>>(additionalFilter)
            : menuItems;
    };
